/* globals Namespace, Vue */
(function (ns, Vue) {
    'use strict';

    var VUE = {
        APPOINTMENT: 'vue_appointment',
        APPOINTMENT_OPENINGS: 'vue_appointment_openings',
        COMPANY_ADDRESS: 'vue_company_address',
        COMPANY_REVIEWS: 'vue_company_reviews',
        COMPANY_SEV: 'vue_company_sev',
        COMPANY_OFF: 'vue_company_off',
        COMPANY_MEDIA: 'vue_company_media',
        COMPANY_PRODUCTS: 'vue_company_prd',
        LANDING_POPULATION: 'vue_landing_pop',
        COMITE: 'vue_comite_collaborator'
    };

    if (document.getElementById(VUE.COMPANY_ADDRESS) !== null) {
        /* eslint-disable no-new */
        new Vue({
            el: '#vue_company_address',
            computed: {
                showSwitchHeadquarterModal: function () {
                    return this.$store.getters['switchHeadquarter/isShowed'];
                },
                showAvailabilityPhoneModal: function () {
                    return this.$store.getters['availabilityPhone/isShowed'];
                }
            },
            store: ns.vuex.store,
            created: function () {
                this.$store.dispatch('userData/requestGeoIpStatus');
            }
        });
    }

    if (document.getElementById(VUE.APPOINTMENT_OPENINGS) !== null) {
        new Vue({
            el: '#vue_appointment_openings',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.APPOINTMENT) !== null) {
        new Vue({
            el: '#vue_appointment',
            computed: {
                showAvailabilityWeekModal: function () {
                    return this.$store.getters['availabilityWeek/isShowed'];
                }
            },
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.COMPANY_REVIEWS) !== null) {
        new Vue({
            el: '#vue_company_reviews',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.COMPANY_SEV) !== null) {
        new Vue({
            el: '#vue_company_sev',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.COMPANY_OFF) !== null) {
        new Vue({
            el: '#vue_company_off',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.COMPANY_MEDIA) !== null) {
        new Vue({
            el: '#vue_company_media',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.COMITE) !== null) {
        new Vue({
            el: '#vue_comite_collaborator',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.COMPANY_PRODUCTS) !== null) {
        new Vue({
            el: '#vue_company_prd',
            store: ns.vuex.store
        });
    }

    if (document.getElementById(VUE.LANDING_POPULATION) !== null) {
        new Vue({
            el: '#vue_landing_pop',
            store: ns.vuex.store,
            computed: {
                companies: function () {
                    return this.$store.getters['landingPopulation/companies'];
                }
            }
        });
    }

}(Namespace, window.Vue));
